import { useEffect, useRef } from 'react'
import { supabase } from '../shared/lib/supabase'

/**
 * Subscribe to Supabase realtime INSERT events on a table.
 * Cleans up the channel on unmount or when dependencies change.
 */
export function useRealtimeSubscription({ table, filter, onInsert, enabled = true }) {
  const channelRef = useRef(null)

  useEffect(() => {
    if (!enabled || !onInsert) return

    const channelName = `${table}:${filter || 'all'}:${Date.now()}`
    const config = {
      event: 'INSERT',
      schema: 'public',
      table,
    }
    if (filter) config.filter = filter

    const channel = supabase
      .channel(channelName)
      .on('postgres_changes', config, (payload) => {
        onInsert(payload.new)
      })
      .subscribe()

    channelRef.current = channel

    return () => {
      if (channelRef.current) {
        supabase.removeChannel(channelRef.current)
        channelRef.current = null
      }
    }
  }, [table, filter, enabled]) // intentionally omit onInsert to avoid re-subscribing on every render

  return channelRef
}
